import { bffCrmPersonAccumulators } from '@fireflyhealth/api'
import type { BffCrmPersonAccumulatorsRetrieveResponse } from '@fireflyhealth/api'

import { keepPreviousData } from '@tanstack/react-query'
import { useQuery } from '~/shared/hooks/query'

/**
 * Fetches a member's accumulator progress for one plan year, the years on offer, and the one it
 * came from. `policyConfigurationId` must be one of the returned `policy_configurations`; any
 * other is a 400. Disabled until `personId` is available.
 */
export const useGetPersonAccumulators = (variables: {
  personId: number | undefined
  policyConfigurationId?: number
}) => {
  const { personId, policyConfigurationId } = variables
  return useQuery<BffCrmPersonAccumulatorsRetrieveResponse>(
    personId != null
      ? bffCrmPersonAccumulators.retrieveQueryKey(
          { person_id: personId },
          { policy_configuration_id: policyConfigurationId },
        )
      : ['retrieveBffCrmPersonAccumulators', {}],
    async () =>
      (
        await bffCrmPersonAccumulators.retrieve(
          { person_id: Number(personId) },
          { params: { policy_configuration_id: policyConfigurationId } },
        )
      ).data,
    { enabled: personId != null, placeholderData: keepPreviousData },
    { error: 'Failed to fetch accumulators' },
  )
}
